/**
 * Shared product builder parsing, escaping, and money-formatting helpers.
 * Load before files that read window.Express.productBuilderUtils.
 */
(() => {
  window.Express = window.Express || {};

  function parseJson(value) {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  function cloneJson(value) {
    if (!value || typeof value !== 'object') return null;

    try {
      return JSON.parse(JSON.stringify(value));
    } catch (_error) {
      return null;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/"/g, '&quot;');
  }

  function formatMoney(cents, config) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: config.product?.currencyCode || 'AUD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format((Number(cents) || 0) / 100);
  }

  function formatThemeMoney(value) {
    return '$' + Number(value || 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function formatDelta(value, included, config) {
    return included || Number(value || 0) === 0 ? 'Included' : `+${formatMoney(Number(value || 0), config)}`;
  }

  window.Express.productBuilderUtils = {
    parseJson,
    cloneJson,
    escapeHtml,
    escapeAttr,
    formatMoney,
    formatThemeMoney,
    formatDelta,
  };
})();
